import styled from 'styled-components'
import UnreadIndicator from '../StyledUnreadIndicator'

export default styled(UnreadIndicator)`
  left: 60px;
  right: unset;
  top: -5px;
  z-index: 10;
`
